<template>
<div class="l-loading">
  <div class="l-loading__content">
    <Text className="c-text--bold" text="画像をつくっています"></Text>
    <Img src="/assets/img/img_skate-def.gif"></Img>
  </div>
  <div class="l-loading__ads">
    <div class="l-loading__ads-item">
      <a class="gtm-ad01-img-loading" href="https://px.a8.net/svt/ejp?a8mat=3HBY4V+5FA7YY+3L4M+6RHFL" target="_blank" rel="nofollow">
        <Img class="c-img" src="https://www29.a8.net/svt/bgt?aid=210509455328&wid=002&eno=01&mid=s00000016735001136000&mc=1"></Img>
      </a>
      <img border="0" width="1" height="1" src="https://www14.a8.net/0.gif?a8mat=3HBY4V+5FA7YY+3L4M+6RHFL" alt="">
      <a class="gtm-ad01-txt-loading" href="https://px.a8.net/svt/ejp?a8mat=3HBY4V+5FA7YY+3L4M+6L9O2" target="_blank" rel="nofollow">世界最大級のオンライン学習サイトUdemy</a>
      <img border="0" width="1" height="1" src="https://www11.a8.net/0.gif?a8mat=3HBY4V+5FA7YY+3L4M+6L9O2" alt="">
    </div>
    <div class="l-loading__ads-item">
      <a class="gtm-ad02-img-loading" href="https://px.a8.net/svt/ejp?a8mat=3HBY4V+4POKYI+50+2HOYA9" target="_blank" rel="nofollow">
        <Img class="c-img" src="https://www28.a8.net/svt/bgt?aid=210509455285&wid=002&eno=01&mid=s00000000018015065000&mc=1"></Img>
      </a>
      <img border="0" width="1" height="1" src="https://www11.a8.net/0.gif?a8mat=3HBY4V+4POKYI+50+2HOYA9" alt="">
      <a class="gtm-ad02-txt-loading" href="https://px.a8.net/svt/ejp?a8mat=3HBY4V+4POKYI+50+2HCQGY" target="_blank" rel="nofollow">【早い者勝ち！】.com／.net／.jp ドメイン取るならお名前.com</a>
      <img border="0" width="1" height="1" src="https://www12.a8.net/0.gif?a8mat=3HBY4V+4POKYI+50+2HCQGY" alt="">
    </div>
  </div>
</div>
</template>

<script>
import Text from '@/components/atoms/Text.vue'
import Img from '@/components/atoms/Img.vue'

export default {
  components: {
    Text,
    Img
  }
}
</script>

<style lang="scss" scoped>
.l-loading {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__ads {
    display: flex;
    justify-content: space-around;

    &-item{
      width: 40%;
      a {
        display: block;
      }
      @include media-queries-sp {
        width: 45%;
      }
    }
  }
}
</style>
